export const PHONE_NUMBER_SET = 'PHONE_NUMBER_SET';
export const PHONE_NUMBER_ERROR = 'PHONE_NUMBER_ERROR';
export const PHONE_NUMBER_CLEAR_ERROR = 'PHONE_NUMBER_CLEAR_ERROR';